export default __webpack_public_path__ + "static/media/undraw_Reading_book_re_kqpk.9e840770.svg";